module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-count text-uppercase"
  }, [_c('span', {
    staticClass: "eye shaped"
  }), _vm._v(" "), _c('span', [_vm._v("\n        " + _vm._s(_vm.viewerCount) + " "), _c('span', {
    staticClass: "live-text"
  }, [_vm._v("live")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da98e302"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Viewers.vue
// module id = 2596
// module chunks = 13